<template>
  <div class="zj-layout-main-content bgcolor scrollable" style="overflow: auto">
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="16rem">
      <zj-layout-container>
        <zj-layout-header>
          <div class="listtitle">预警详情</div>
        </zj-layout-header>
      </zj-layout-container>
      <el-form-item label="预警级别" prop="AlerteLevel" style="width: 118rem">
        <el-select
          v-model="ruleForm.AlerteLevel"
          placeholder="请选择"
          style="width: 100%"
          :disabled="IsEdit"
        >
          <el-option
            v-for="item in AlerteLevelArr"
            :key="item.ItemKey"
            :label="item.Description"
            :value="item.ItemValue"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="预警类型" prop="AlertType" style="width: 118rem">
        <el-select
          v-model="ruleForm.AlertType"
          placeholder="请选择"
          style="width: 100%"
          :disabled="IsEdit"
        >
          <el-option
            v-for="item in AlertTypeArr"
            :key="item.ItemKey"
            :label="item.Description"
            :value="item.Extend1"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="预警时间" prop="BeginDate" v-if="IsEdit">
        <el-date-picker
          type="datetime"
          placeholder="选择日期"
          v-model="ruleForm.BeginDate"
          style="width: 40rem"
          :disabled="IsEdit"
        ></el-date-picker>
      </el-form-item>
      <!-- <el-form-item label="预警结束时间" prop="EndDate" v-if="IsEdit">
      <el-date-picker
        type="datetime"
        placeholder="选择日期"
        v-model="ruleForm.EndDate"
        style="width:40rem;"
        :disabled="IsEdit"
      ></el-date-picker>     
      </el-form-item>-->
      <el-form-item label="预警信息" prop="ContentDemo" style="width: 118rem">
        <el-input type="textarea" v-model="ruleForm.ContentDemo" v-bind:disabled="IsEdit"></el-input>
      </el-form-item>
      <el-form-item label="预警来源" prop="SourceDesc" style="width: 60rem; display: inline-block">
        <el-select
          v-model="ruleForm.SourceDesc"
          placeholder="请选择"
          style="width: 100%"
          v-bind:disabled="IsEdit"
        >
          <el-option
            v-for="item in channelArr"
            :key="item.ItemKey"
            :label="item.Description"
            :value="item.Description"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="预警地址" prop="Location" style="width: 118rem">
        <el-input v-model="ruleForm.Location" v-bind:disabled="IsEdit"></el-input>
      </el-form-item>
      <el-form-item label="求助报警人" prop="Contact" style="width: 60rem; display: inline-block">
        <el-input v-model="ruleForm.Contact" v-bind:disabled="IsEdit"></el-input>
      </el-form-item>
      <el-form-item label="联系方式" prop="Phone" style="width: 58rem; display: inline-block">
        <el-input v-model="ruleForm.Phone" v-bind:disabled="IsEdit"></el-input>
      </el-form-item>
      <el-form-item label="处理状态" prop="ProcessStatus" style="width: 118rem" v-if="IsEdit">
        <el-select
          v-model="ruleForm.ProcessStatus"
          placeholder="请选择"
          style="width: 100%"
          :disabled="IsEdit"
        >
          <el-option
            v-for="item in ProcessStatusArr"
            :key="item.ItemKey"
            :label="item.Description"
            :value="item.ItemValue"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="处理方式" prop="ProcessWay" v-if="IsEdit">
        <el-radio-group
          v-model="ruleForm.ProcessWay"
          :disabled="isCompelete"
          @change="changeProcessWay"
        >
          <el-radio label="1">转为应急事件</el-radio>
          <el-radio label="2">已知晓</el-radio>
          <el-radio label="3">忽略</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="预警结案说明" prop="ProcessConclusion" style="width: 118rem" v-if="IsEdit">
        <el-input type="textarea" v-model="ruleForm.ProcessConclusion" :disabled="isCompelete"></el-input>
      </el-form-item>
      <el-form-item class="right" style="width: 134rem">
        <el-button @click="onBack()">返回</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')" v-if="!isCompelete">提交</el-button>
        <!-- <el-button @click="resetForm('')" >重置</el-button> -->
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import MyApis from "../../../apis";
import ZJApp from "../../../../../app";
export default {
  name: "ElaryWarningInfo",
  controller: "UI",
  action: "ElaryWarningInfo",
  data() {
    return {
      ruleForm: {
        AlertType: null,
        AlerteLevel: null,
        Content: "",
        BeginDate: "",
        EndDate: "",
        Location: "",
        Source: 3,
        SourceDesc: null,
        ProcessStatus: "",
        // ProcessStatusShow:"", //处理状态显示
        Contact: null,
        Phone: null,
        ProcessWay: "", // 处理方式
        ContentDemo: ""
      },
      rules: {
        AlerteLevel: [
          { required: true, message: "请选择预警级别", trigger: "change" }
        ],
        AlertType: [
          { required: true, message: "请选择预警类型", trigger: "change" }
        ],
        SourceDesc: [
          { required: true, message: "请选择预警来源", trigger: "change" }
        ],
        ContentDemo: [
          { required: true, message: "请填写预警信息", trigger: "blur" }
        ],
        ProcessWay: [
          { required: true, message: "请选择处理方式", trigger: "change" }
        ]
      },
      IsEdit: false,
      AlertTypeArr: [], //预警类型
      AlerteLevelArr: [], //预警级别
      EmergencyChannel: [],
      BusinessChannel: [],
      channelArr: [],
      ProcessStatusArr: [],
      isCompelete: false
    };
  },
  watch: {
    "ruleForm.AlertType": function() {
      if (this.ruleForm.AlertType == "13") {
        this.channelArr = this.EmergencyChannel;
      } else {
        this.channelArr = this.BusinessChannel;
      }
    },
    channelArr: function() {
      if (this.$route.query.type == "add") {
        this.ruleForm.SourceDesc = null;
      }
    }
  },
  created: function() {
    this.search();
    this.IsEdit = this.$route.query.type == "add" ? false : true;
    this.isCompelete = this.$route.query.type == "look" ? true : false;
    //预警级别
    this.alarmLevel();
    //预警类型
    this.getAlarmType();
    // 预警来源
    this.EmergencyCallChannel();
    this.BusinessCallChannel();
    // 处理状态
    this.getProcessstatus();
  },
  mounted: function() {},
  methods: {
    // 弹出一个错误消息
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox"
      });
    },
    alarmLevel() {
      //预警级别
      this.config
        .getUValue("BusinessAlarm:AlertLevel", "")
        .then(d => {
          console.log("预警级别");
          console.log(d);
          this.AlerteLevelArr = d.JValue;
        })
        .catch(e => console.error(e));
    },
    getAlarmType() {
      //预警类型
      this.config
        .getUValue("BusinessAlarm:AlertType", "")
        .then(d => {
          console.log("预警类型");
          console.log(d);
          this.AlertTypeArr = d.JValue;
        })
        .catch(e => console.error(e));
    },
    search() {
      let ResourcesId = this.$route.query.Id;
      if (ResourcesId) {
        let searchInfo = {
          Id: this.$route.query.Id
        };
        new MyApis.ServiceAlarmApi()
          .GetItemById(searchInfo)
          .then(r => {
            r = r.data.Data;
            r.ProcessWay = r.ProcessWay === 0 ? "2" : r.ProcessWay + "";

            this.ruleForm = r;
            if (r.ProcessStatus == "2") {
              this.isCompelete = true;
            }
            if (r.AlertType === "0") {
              r.SourceDesc = "硬件设备";
            }
            if (this.isJson(r.Content)) {
              const deviceInfo = JSON.parse(r.Content);
              this.ruleForm.ContentDemo =
                deviceInfo.DeviceName + "硬件设备发出报警";
            } else {
              this.ruleForm.ContentDemo = r.Content;
            }
            if (r.SourceDesc == null || r.SourceDesc == "")
              r.SourceDesc = "其他";
          })
          .catch(e => {
            console.log(e);
            //  this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      }
    },
    //返回按钮
    onBack() {
      this.$router.go(-1); //返回上一层
    },
    EmergencyCallChannel() {
      //预警来源
      this.config
        .getUValue("EmergencyCall:HelpChannel", "")
        .then(d => {
          let arr=[];
          for(let i=0;i<d.JValue.length;i++){
            if(d.JValue[i].Description!="小程序"&&d.JValue[i].Description!="官方网站"&&d.JValue[i].Description!="公众号")
            {
              arr.push(d.JValue[i]);
            }
          }
          this.EmergencyChannel = arr;
        })
        .catch(e => console.error(e));
    },
    BusinessCallChannel() {
      //预警来源
      this.config
        .getUValue("BusinessAlarm:AlarmChanel", "")
        .then(d => {
          let arr=[];
          for(let i=0;i<d.JValue.length;i++){
            if(d.JValue[i].Description!="小程序"&&d.JValue[i].Description!="官方网站"&&d.JValue[i].Description!="公众号")
            {
              arr.push(d.JValue[i]);
            }
          }
          this.BusinessChannel = arr;
        })
        .catch(e => console.error(e));
    },
    changeProcessWay(val) {
      if (val === "1") {
        this.$confirm("确认转为应急事件吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          let path = `/plugin/Emergency/UI/NewEvent?AlarmId=${this.ruleForm.Id}`;
          this.$router.push(path);
        });
      }
    },
    getProcessstatus() {
      //预警处理状态
      this.config
        .getUValue("EmergencyCall:ProcessStatus", "")
        .then(d => {
          this.ProcessStatusArr = d.JValue;
        })
        .catch(e => console.error(e));
    },
    isJson(str) {
      if (typeof str == "string") {
        try {
          var obj = JSON.parse(str);
          if (typeof obj == "object" && obj) {
            return true;
          } else {
            return false;
          }
        } catch (e) {
       
          return false;
        }
      }
    },
    save() {
      let status = this.ruleForm.ProcessStatus;
      if (status == "0" || status == "") {
        //0是待处理 1是待结案

        if (this.ruleForm.ProcessWay == "1") {
          this.ruleForm.ProcessWay = parseInt(this.ruleForm.ProcessWay);
          this.ruleForm.FinishDate = new Date();
          this.ruleForm.AcceptDate = new Date();
          this.ruleForm.ProcessConclusion = "已转为应急事件";
          this.ruleForm.ProcessStatus = "2";
        } else {
          //业务告警，选择任何处理方式，处理状态都为已完结
          this.ruleForm.ProcessWay = parseInt(this.ruleForm.ProcessWay);
          this.ruleForm.AcceptDate = new Date();
          this.ruleForm.ProcessStatus = "2";
        }
      } else if (status == "1") {
        this.ruleForm.FinishDate = new Date();
        this.ruleForm.ProcessStatus = "2";
      }
      if (this.$route.query.type == "add") {
        let obj = {
          AlertType: this.ruleForm.AlertType,
          AlerteLevel: this.ruleForm.AlerteLevel,
          Content: this.ruleForm.ContentDemo,
          Source: 3,
          Creater: ZJApp.ZJUser.current.UserName,
          Modifier: ZJApp.ZJUser.current.UserName,
          Location: this.ruleForm.Location,
          Contact: this.ruleForm.Contact,
          Phone: this.ruleForm.Phone,
          SourceDesc: this.ruleForm.SourceDesc
        };
        new MyApis.ServiceAlarmApi()
          .AddItem(obj)
          .then(r => {
            r = r.data.Data;
            this.$message({
              type: "success",
              message: r ? "保存成功！" : "保存失败！"
            });
            this.logInfo.ActionName = "待处理预警添加";
            this.logInfo.LogMessage = "待处理预警添加成功";
            this.logInfo.ModuleName = "业务告警";
            this.logInfo.PageName = "预警信息-待处理详情";
            this.addOperationLog();
            this.$router.go(-1); //返回上一层
          })
          .catch(e => {
            console.log(e);
            // this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      } else {
        new MyApis.ServiceAlarmApi()
          .UpdateItem(this.ruleForm)
          .then(r => {
            r = r.data.Data;
            this.$message({
              type: "success",
              message: r ? "保存成功！" : "保存失败！"
            });
            this.logInfo.ActionName = "处理预警";
            this.logInfo.LogMessage = "预警处理成功";
            this.logInfo.ModuleName = "业务告警";
            this.logInfo.PageName = "预警信息-待处理详情";
            this.addOperationLog();
            this.$router.go(-1); //返回上一层
          })
          .catch(e => {
            console.log(e);
            //  this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      }
    },
    //保存
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.save();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
      //this.$router.go(-1); //返回上一层
    }
  }
};
</script>
